import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddressParserService, ParsedAddress } from './address-parser.service';

export interface AddressImportDialogData {
  initialText?: string;
}

@Component({
  selector: 'app-address-import-dialog',
  templateUrl: './address-import-dialog.component.html',
  styleUrls: ['./address-import-dialog.component.css']
})
export class AddressImportDialogComponent {
  inputText = '';
  parsedAddresses: ParsedAddress[] = [];

  constructor(
    private dialogRef: MatDialogRef<AddressImportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddressImportDialogData,
    private addressParser: AddressParserService
  ) {
    this.inputText = data?.initialText || '';
    this.refreshPreview();
  }

  refreshPreview(): void {
    this.parsedAddresses = this.addressParser.extractAddresses(this.inputText);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.refreshPreview();
    if (this.parsedAddresses.length === 0) {
      return;
    }
    this.dialogRef.close(this.parsedAddresses);
  }
}
